var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CodesHistoryPanel',{attrs:{"doorphone-id":_vm.$route.params.id,"include-doorphone-address":false,"temp-route":"DetailDoorphoneTempCodeProvisionHistory","service-route":"DetailDoorphoneServiceDoorCodeHistory"}})
}
var staticRenderFns = []

export { render, staticRenderFns }